module.exports = __webpack_public_path__ + "static/media/ready-for-a-nap.a72554ac.svg";